import handleCart from "./handleCart";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    handleCart,
})

export default rootReducer;